import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "user-dataset-editor" }
const _hoisted_2 = {
  key: 0,
  class: "ude__label_input"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 1,
  class: "ude__label_input"
}
const _hoisted_5 = { class: "ude__button-container" }

import { ref, watch, onUnmounted  } from 'vue';
import { useTempoStore } from "../stores/app";
import { UserDataset } from '@/types';

type Props = {
  nameOnly?: boolean;
  colorOnly?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDatasetEditor',
  props: /*@__PURE__*/_mergeModels({
    nameOnly: { type: Boolean, default: false },
    colorOnly: { type: Boolean, default: false }
  }, {
    "modelValue": {
  type: Object as () => UserDataset,
  required: true,
},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["complete"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const accentColor2 = useTempoStore().accentColor2;

const props = __props;

const model = _useModel(__props, "modelValue");

const emit = __emit;

const name = ref(model.value.name || '');
const color = ref(model.value.customColor || model.value.region.color || 'white');
const changed = ref(false);

watch(name, () => {
  changed.value = true;
});
watch(color, () => {
  changed.value = true;
});

function save() {
  if (model.value) {
    model.value.name = name.value;
    if (model.value.plotlyDatasets) {
      model.value.plotlyDatasets[1].name = name.value;
    }
    model.value.customColor = color.value;
  }
  emit('complete');
}

function cancel() {
  emit('complete');
}


function handleKeydown(event: KeyboardEvent) {
  if (event.key === 'Enter' && changed.value) {
    save();
  } else if (event.key === 'Escape') {
    cancel();
  }
}

window.addEventListener('keydown', globalKeydownHandler);

function globalKeydownHandler(event: KeyboardEvent) {
  const skipTags = ['INPUT', 'TEXTAREA', 'BUTTON', 'SELECT'];
  if (
    event.target && 
    skipTags.includes((event.target as HTMLElement).tagName)) {
    return; 
  }
  handleKeydown(event);
}
onUnmounted(() => {
  window.removeEventListener('keydown', globalKeydownHandler);
});


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    width: "fit-content",
    class: "mx-auto"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, { class: "pb-0" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!props.colorOnly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", { for: "ude-name" }, "Edit Name:", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "ude-name",
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                    placeholder: model.value.name ?? 'Dataset Name',
                    minlength: "3",
                    onKeydown: handleKeydown
                  }, null, 40, _hoisted_3), [
                    [_vModelText, name.value]
                  ])
                ]))
              : _createCommentVNode("", true),
            (!props.nameOnly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { for: "ude-color" }, " Edit Color:", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "ude-color",
                    type: "color",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((color).value = $event)),
                    onKeydown: handleKeydown
                  }, null, 544), [
                    [_vModelText, color.value]
                  ]),
                  _createVNode(_component_v_btn, {
                    class: "use_reset-color",
                    variant: "outlined",
                    color: model.value.region.color,
                    size: "small",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (color.value = model.value.region.color))
                  }, {
                    default: _withCtx(() => [
                      _cache[4] || (_cache[4] = _createTextVNode(" Reset ", -1)),
                      _createElementVNode("div", {
                        class: "ude_color-swatch",
                        style: _normalizeStyle({backgroundColor: model.value.region.color})
                      }, null, 4)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_btn, {
          variant: "flat",
          size: "small",
          onClick: cancel
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          color: _unref(accentColor2),
          size: "small",
          onClick: save,
          disabled: !changed.value
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["color", "disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})